<template>
	<div class="leasing-calculator">
		<div class="header">
			<a href="javascript:void(0)" @click="$router.back()">חזרה</a>
		</div>
		<form action="">
			<div class="form-group">
				<label>
					<input type="checkbox" name="buy_back" v-model="leasingCalculator.buyBack">
					<span>Buy back</span>
				</label>
			</div>
			<div class="form-group">
				<label for="expected_travel">נסועה</label>
				<select
						class="pm-input"
						name="expected_travel"
						id="expected_travel"
						v-model="leasingCalculator.expectedTravel"
				></select>
			</div>
			<div class="form-group">
				<div class="flex align-items-center">
					<label v-if="!monthsLabel">חודשים </label>
					<label v-else>{{monthsLabel}}</label>
					<div class="pm-radio-group full-width">
						<label v-for="(payment, pIndex) in availablePayments" :key="pIndex">
							<input type="radio" :disabled="payment.disabled" name="payments" v-model="leasingCalculator.payments" :value="payment.value">
							<span>{{ payment.value }}</span>
						</label>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="range-wrap">
					<label v-if="!imprestLabel">מקדמה</label>
					<label v-else>{{imprestLabel}}</label>
					<slider
							class="range-slider"
							v-model="leasingCalculator.imprest"
							:tooltips="true"
							:min="0"
							:lazy="false"
							:step="500"
							:max="calculator.car_cost"
							direction="rtl"
					></slider>
					<div class="pm-input price-view"><span>{{ numberFormat(calculator.imprest) }}</span> ₪</div>
				</div>
			</div>
			<div class="text-center">
				<button type="submit">חשב</button>
			</div>
		</form>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import numeral from "numeral"
import Slider from '@vueform/slider'

export default {
	name: "LeasingCalculator",
	components: {Slider},
	data(){
		return {
			leasingCalculator: {
				buyBack: false,
				expectedTravel: 25,
				payments: 24,
				imprest: 0
			}
		}
	},
	computed:{
		availablePayments() {
			let p = []
			for (let i = 24; i <= 60; i = i + 12) {
				if(i === 96){
					i = i + 4
				}
				p.push({value: i, disabled: false})
			}
			return p
		},
		calculator: {
			get(){
				return this.$store.getters.calculator
			},
			set(value){
				this.$store.commit('calculator', value)
			}
		},
		...mapGetters(['monthsLabel','imprestLabel'])
	},
	methods: {
		numberFormat(number){
			return numeral(number).format("0,0")
		}
	}
}
</script>

<style lang="scss">
.leasing-calculator {
	color: #fff;
	width: 470px;
	max-width: 100vw;

	.header {
		margin-bottom: 15px;
	}

	input[type="checkbox"]{
		transform: scale(1.5);
	}

	.range-wrap {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		gap: 1.875rem;

		.range-slider {
			flex-grow: 1;
		}
	}

	.slider-tooltip {
		background-color: transparent;
		border: none;
		display: none;
	}

	.slider-handle.slider-active .slider-tooltip{
		display: block;
	}

	.price-view {
		min-width: 150px;
	}

	a,label,p {
		color: #fff;
	}

	.form-group {
		margin-bottom: 15px;

		label {
			display: flex;
			margin-bottom: 5px;
			gap: 10px;
		}
	}

	.pm-input {
		background: #FFFFFF;
		border: 1px solid #E7E7E7;
		box-sizing: border-box;
		box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
		border-radius: 24px 0 24px 24px;
    height: 45px;
		color: #2E3172;
		min-width: 111px;
		font-size: 1.125rem;
		padding: 5px;

		&:not(select){
			padding: 4px;
			font-size: 1.25rem;
			font-weight: 700;
			text-align: center;
		}
	}

	.text-center {
		text-align: center;
	}

	button {
		background-image: none;
		background-color: #BD2E39;
		border-radius: 5px;
		border: none;
		color: #fff;
		font-size: 1.125rem;
		min-width: 230px;
		padding: 5px;
		cursor: pointer;
	}

	.pm-radio-group {
		display: flex;
		flex-flow: row nowrap;
		border-radius: 5px;

		&.full-width {
			flex-grow: 1;

			label {
				flex-grow: 1;
				text-align: center;
			}
		}

		label {
			font-size: 1.125rem;
			cursor: pointer;
			user-select: none;

			input[type="radio"] {
				display: none;
			}

			&:not(:first-child){
				margin-right: -6px;
			}

			&:not(:last-child) span {
				padding: 10px 20px 10px 26px;
			}

			> span {
				padding: 10px 20px;
				background-color: #fff;
				color: #2E3172;
				border-radius: 5px;
				display: block;
			}

			> input[type="radio"]:checked + span {
				background-color: #BD2E39;
				color: #fff;
			}

			> input[disabled] + span {
				background-color: #737373;
				color: #fff;
				cursor: not-allowed;
			}
		}
	}

	@media (max-width: 1024px) {
		.pm-radio-group {
			label {
				font-size: 1rem;
				width: auto !important;

				&:not(:last-child) span {
					padding: 10px 10px 10px 16px;
				}

				> span {
					padding: 10px 10px;
				}
			}
		}
	}
}
</style>
